var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"iconfont",class:_vm.iconClass,style:(_vm.iconStyle),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }